import { Check, Circle } from 'lucide-react';
import { cn } from '../../../lib/cn';
import type { PolicyCheck } from '../password-policy';

/** Walidacja na żywo: lista warunków hasła (spełniony = zielony znacznik). */
export function PasswordChecklist({ checks, id }: { checks: PolicyCheck[]; id?: string }) {
  return (
    <ul id={id} className="flex flex-col gap-1" aria-label="Wymagania hasła">
      {checks.map((check) => (
        <li
          key={check.id}
          className={cn('flex items-center gap-2 text-caption', check.ok ? 'text-fg-secondary' : 'text-fg-muted')}
        >
          {check.ok ? (
            <Check size={14} strokeWidth={2} aria-hidden className="shrink-0 text-success" />
          ) : (
            <Circle size={14} strokeWidth={1.75} aria-hidden className="shrink-0 text-line-strong" />
          )}
          <span>{check.label}</span>
          <span className="sr-only">{check.ok ? ' (spełnione)' : ' (niespełnione)'}</span>
        </li>
      ))}
      <li className="text-caption text-fg-muted">Bez wymogu wielkich liter i cyfr. Najlepiej kilka słów.</li>
    </ul>
  );
}
